export const formatDateYmd = (value) => {
  const d = new Date(value || "");
  if (Number.isNaN(d.getTime())) return "--";
  return d.toLocaleDateString("en-CA").replace(/-/g, "/");
};

export const formatNoteTime = (note, separator = " - ") => {
  const timeIn = String(note?.timeIn || "").trim();
  const timeOut = String(note?.timeOut || "").trim();
  if (timeIn && timeOut && timeIn === timeOut) return timeIn;
  if (timeIn && timeOut) return `${timeIn}${separator}${timeOut}`;
  return timeIn || timeOut || "N/A";
};

export const normalizeLocationText = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "Client's home";
  return raw.replace(/^location\s*:\s*/i, "");
};

export const shouldShowObservation = (key, value) => {
  const text = String(value || "").trim();
  if (!text) return false;
  if ((key === "status" || key === "direction") && text.toLowerCase() === "unknown") {
    return false;
  }
  return true;
};

export const getVisibleObservationEntries = (note) =>
  Object.entries(note?.observations || {}).filter(([key, value]) =>
    shouldShowObservation(key, value),
  );
